import { Injectable } from '@angular/core';
import { AttributeSetCreate, AttributeSetEntity, AttributeSetUpdate } from '@models';
import { map } from 'rxjs';
import { BaseApi } from './_base-api';

@Injectable({
  providedIn: 'root',
})
export class AttributeSetApiService extends BaseApi<AttributeSetEntity, AttributeSetCreate, AttributeSetUpdate> {
  constructor() {
    super('/AdminPanel/GetAttributeSetList', {
      post: '/AdminPanel/AddAttributeSet',
      get: '/AdminPanel/GetAttributeSetList',
    });
  }

  override get(id: number) {
    return http$
      .get<AttributeSetEntity>(`/AdminPanel/GetAttributeSet?AttributeSetId=${id}`)
      .pipe(map((response) => ({ ...response, id })));
  }

  // @ts-ignore
  override delete(id: number) {
    return http$.delete('/AdminPanel/DeleteAttributeSet', { body: { id: id } });
  }

  // @ts-ignore
  override update(model: AttributeSetUpdate) {
    return http$.put('/AdminPanel/EditAttributeSet', model);
  }

  getAttributeSetItems() {
    return super.getItemRecords((item) => ({ label: item.name, value: item.id }));
  }
}
